import React,{useEffect} from "react";
import "./TermsAndCondition.css";
import HomeHeader from "../../components/header/HomeHeader";
import CommonFooter from "../../components/footer/CommonFooter";
import Breadcrumb from "../../components/breadcrumb";

const TermsAndCondition = () => {

  useEffect(()=>{
    window.scrollTo({
      top:0,
      behavior:"smooth"
    })
  },[])
  return (
    <div className="terms-and-conditions">
      {/* <HomeHeader /> */}
      <Breadcrumb
        items={[
          {
            label: "Home",
            path: "/",
          },
          {
            label: "Terms & Conditions",
            isActive: true,
          },
        ]}
      />
      <main className="terms-and-conditions__main">
        <div className="terms-and-conditions__container">
          <div className="terms-and-conditions__content">
            <p className="terms-and-conditions__intro">
              Welcome to Yug Mantra - your premier destination for exclusive blouse designs. These Terms and Conditions govern your use of our website and services. By accessing or using our platform, you agree to be bound by these terms.
            </p>

            <div className="terms-and-conditions__section">
              <h2 className="terms-and-conditions__section-title">1. Acceptance of Terms</h2>
              <p>By accessing and using Yug Mantra for blouse shopping, you accept and agree to be bound by the terms and provision of this agreement.</p>
            </div>

            <div className="terms-and-conditions__section">
              <h2 className="terms-and-conditions__section-title">2. Use License</h2>
              <p>Permission is granted to temporarily download one copy of the materials (information or software) on Yug Mantra's website for personal, non-commercial transitory viewing only.</p>
            </div>

            <div className="terms-and-conditions__section">
              <h2 className="terms-and-conditions__section-title">3. Blouse Product Information</h2>
              <p>We strive to display accurate blouse information, including prices, descriptions, sizes, and images. However, we do not warrant that blouse descriptions or other content is accurate, complete, reliable, current, or error-free.</p>
            </div>

            <div className="terms-and-conditions__section">
              <h2 className="terms-and-conditions__section-title">4. Pricing and Payment</h2>
              <ul className="terms-and-conditions__list">
                <li>All blouse prices are in Indian Rupees (INR) unless otherwise stated</li>
                <li>Blouse prices are subject to change without notice</li>
                <li>Payment must be made at the time of blouse order placement</li>
                <li>We accept various payment methods including credit/debit cards and digital wallets</li>
              </ul>
            </div>

            <div className="terms-and-conditions__section">
              <h2 className="terms-and-conditions__section-title">5. Blouse Shipping and Delivery</h2>
              <ul className="terms-and-conditions__list">
                <li>Blouse delivery times are estimates and may vary</li>
                <li>Shipping costs will be clearly displayed during checkout</li>
                <li>Risk of loss and title for blouses pass to you upon delivery</li>
                <li>Custom-made blouses may require additional processing time</li>
              </ul>
            </div>

            <div className="terms-and-conditions__section">
              <h2 className="terms-and-conditions__section-title">6. Returns and Refunds</h2>
              <p>Please refer to our Return Policy for detailed information about blouse returns, exchanges, and refunds.</p>
            </div>

            <div className="terms-and-conditions__section">
              <h2 className="terms-and-conditions__section-title">7. Privacy Policy</h2>
              <p>Your privacy is important to us. Please review our Privacy Policy, which also governs your use of the website.</p>
            </div>

            <div className="terms-and-conditions__section">
              <h2 className="terms-and-conditions__section-title">8. Contact Information</h2>
              <div className="terms-and-conditions__contact">
                <p><strong>Phone:</strong> +91-7490026756</p>
                <p><strong>Email:</strong> info@siddharthfashion.com</p>
              </div>
            </div>
          </div>
        </div>
      </main>

      <CommonFooter />
    </div>
  );
};

export default TermsAndCondition;